import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import FinishedScreen from '../scenes/FinishedScreen';
import SoundAssetKeys from '../SoundAssetKeys';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Monster extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {FinishedScreen} scene 
   */
  constructor(scene) {
    super(scene);

    this.delegate = scene;

    this.body = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Monster_Body, this).setOrigin(0);

    this.leftEye = ABCyaPhaser.Images.addImage(147,111,UIAssetKeys._Monster_Eye,this);
    this.rightEye = ABCyaPhaser.Images.addImage(245, 111, UIAssetKeys._Monster_Eye, this);
    this.mouth = ABCyaPhaser.Images.addImage(192, 140, UIAssetKeys._Monster_MouthClosed, this);
    this.spoon = ABCyaPhaser.Images.addImage(190, 300, UIAssetKeys._Spoon, this).setAngle(-20)
      .setVisible(false);
    this.arm = ABCyaPhaser.Images.addImage(270, 272, UIAssetKeys._Monster_ArmDown, this);

    this.isEating = false;

    /** @type {Phaser.GameObjects.Image[]} */
    this.splashes = [];
  }

  /**
   * 
   * @param {Phaser.GameObjects.Container} container 
   */
  layerArm (container) {
    container.setPosition(this.x, this.y);
    container.add(this.arm);
  }

  setEatType (hasSpoon) {
    this.hasSpoon = hasSpoon;
    if (this.hasSpoon) {
      this.spoon.visible = true;
    }
  }

  sayOooh () {
    this.mouth.setFrame(UIAssetKeys._Monster_MouthOooh);
    this.mouth.y = 140 + this.mouth.height / 2;
    this.oohEyes();
  }

  oohEyes () {
    ABCyaPhaser.Tweens.addTween(this.leftEye, 360, { scale: 1.4 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.leftEye, 200, { scale: 1 }, Phaser.Math.Easing.Linear);
    });
    ABCyaPhaser.Tweens.addTween(this.rightEye, 360, { scale: 1.4 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.rightEye, 200, { scale: 1 }, Phaser.Math.Easing.Linear, () => {
        this.openMouth();
      });
    });
  }

  openMouth () {
    this.mouth.setFrame(UIAssetKeys._Monster_MouthOpen);
    this.mouth.y = 140 + this.mouth.height / 2;
  }

  takeBite (eatAll) {
    this.isEating = eatAll;
    this.openMouth();
    this.armUp();
    this.closeEyes();
    this.alignSpoonUp();
    this.scene.time.delayedCall(400, this.biteFinished, null, this);
    this.totalBites = this.delegate.takeOutBite();
    let n = Phaser.Math.Between(1,100);
    if (n > 58) ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Eat_2, this.scene);
    n = Phaser.Math.Between(1,3);
    ABCyaPhaser.Audio.playOneShot(`Chomp_${n}`, this.scene);
  }

  biteFinished () {
    this.closeMouth();
    this.armDown();
    this.openEyes();

    this.alignSpoonDown();

    if (this.isEating === true) {
      this.scene.time.delayedCall(400, this.takeBite, [this.isEating], this);
    }
  }

  armDown () {
    this.arm.setFrame(UIAssetKeys._Monster_ArmDown);
    this.arm.x = 270;
    this.arm.y = 272;
    this.delegate.monsterArmDown();
  }

  armUp () {
    this.arm.setFrame(UIAssetKeys._Monster_ArmUp);
    this.arm.x = 240;
    this.arm.y = 223;
  }

  alignSpoonDown () {
    if (!this.hasSpoon) return;
    this.spoon.x = 170;
    this.spoon.y = 300 + this.totalBites * 2;
    this.spoon.angle = -210 - this.totalBites;
  }

  openEyes () {
    this.leftEye.setFrame(UIAssetKeys._Monster_Eye);
    this.rightEye.setFrame(UIAssetKeys._Monster_Eye);
  }

  closeEyes () {
    this.leftEye.setFrame(UIAssetKeys._Monster_Eye_Closed);
    this.rightEye.setFrame(UIAssetKeys._Monster_Eye_Closed);
  }

  alignSpoonUp () {
    if (!this.hasSpoon) return;
    this.spoon.x = 190;
    this.spoon.y = 200;
    this.spoon.angle = 20;
  }

  burp (waitTime = 0) {
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._Burp_Excuse_Me, this.scene, 1, false, 1.15, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.scene.time.delayedCall(waitTime, this.openMouth, null, this);
    this.scene.time.delayedCall(waitTime + 680, this.closeMouth, null, this);
  }

  closeMouth () {
    this.mouth.setFrame(UIAssetKeys._Monster_MouthClosed);
    this.mouth.y = 140;
  }

  addSplash (value) {
    const splash = ABCyaPhaser.Images.addImage(118, 136, `FlavorSplash+${value}`, this).setOrigin(0);
    this.splashes.push(splash);
  }

  tick (dt) {
    const len = this.splashes.length - 1;
    for (let i = len; i >= 0; i--) {
      this.splashes[i].y += 100 * dt;
      this.splashes[i].alpha -= dt;
      if (this.splashes[i].alpha <= 0) {
        this.splashes[i].destroy();
        this.splashes.splice(i,1);
      }
    }
  }
}